module.exports = __webpack_public_path__ + "img/information-circle.e9070ef6.svg";